import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { ROLE_READ } from '~/components/routes/administration/roles/permissions'
import { RoleDetailView } from '~/components/routes/administration/roles/role-detail-view'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/administration/roles/$roleId/')({
  staticData: { permission: ROLE_READ },
  component: AdministrationRoleDetailPage,
  params: {
    parse: z.object({ roleId: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function AdministrationRoleDetailPage() {
  const { roleId } = Route.useParams()

  return (
    <>
      <AppHeader>
        <Title>Administration</Title>
      </AppHeader>

      <AppContainer className="space-y-4">
        <RoleDetailView roleId={roleId} />
      </AppContainer>
    </>
  )
}
